// Copyright (c) 2017 Deere & Company

import LaborRateChangeContainer from '../../claim/labor-rate-change/state-connector';

export default {
    component: LaborRateChangeContainer,
    name: 'UPDATE_LABOR_RATES',
    path: ':account'
};



// WEBPACK FOOTER //
// ./src/routes/claims/labor-rate-change.js